import * as __glob_0 from './../cycle.ts';
import * as __glob_1 from './../fade-in.ts';
import * as __glob_2 from './../fade-stagger.ts';
import * as __glob_3 from './../form.ts';
import * as __glob_4 from './../hero-video.ts';
import * as __glob_5 from './../home-nav.ts';
import * as __glob_6 from './../ilya.js';
import * as __glob_7 from './../line.ts';
import * as __glob_8 from './../mask-in.ts';
import * as __glob_9 from './../nav.ts';
import * as __glob_10 from './../preloader.ts';
import * as __glob_11 from './../product-grid.ts';
import * as __glob_12 from './../product-grids.ts';
import * as __glob_13 from './../split.ts';
import * as __glob_14 from './../test.ts';
import * as __glob_15 from './../top-heading.ts';
const modules = { "./../cycle.ts": __glob_0, "./../fade-in.ts": __glob_1, "./../fade-stagger.ts": __glob_2, "./../form.ts": __glob_3, "./../hero-video.ts": __glob_4, "./../home-nav.ts": __glob_5, "./../ilya.js": __glob_6, "./../line.ts": __glob_7, "./../mask-in.ts": __glob_8, "./../nav.ts": __glob_9, "./../preloader.ts": __glob_10, "./../product-grid.ts": __glob_11, "./../product-grids.ts": __glob_12, "./../split.ts": __glob_13, "./../test.ts": __glob_14, "./../top-heading.ts": __glob_15 };
// console.log("modules -> []", modules);

// Extend HTMLElement interface to include our custom property
declare global {
  interface HTMLElement {
    _moduleInitialized?: boolean;
  }
}

export function createCycles(dataAttribute = "module") {
  return Array.from(document.querySelectorAll(`[data-${dataAttribute}]`))
    .map((element) => {
      const htmlElement = element as HTMLElement;
      const attributeValue = htmlElement.dataset[dataAttribute];

      // Check if THIS SPECIFIC ELEMENT is already initialized
      if (htmlElement._moduleInitialized) {
        return null; // Skip this specific element
      }

      const modulePath = modules[`./../${attributeValue}.ts`]
        ? `./../${attributeValue}.ts`
        : `./../${attributeValue}.js`;

      if (modules[modulePath]) {
        // Expecting a default export function
        const moduleFn = (
          modules[modulePath] as {
            default: (el: HTMLElement, dataset: DOMStringMap) => any;
          }
        ).default;
        if (typeof moduleFn === "function") {
          try {
            // Mark THIS SPECIFIC ELEMENT as initialized
            htmlElement._moduleInitialized = true;

            return moduleFn(htmlElement, htmlElement.dataset);
          } catch (error) {
            // Remove the flag if initialization fails
            delete htmlElement._moduleInitialized;
            console.warn(
              `Failed to call default function for ${dataAttribute} "${attributeValue}":`,
              error
            );
            return null;
          }
        } else {
          console.warn(
            `Default export is not a function for ${dataAttribute} "${attributeValue}"`
          );
          return null;
        }
      } else {
        console.warn(`${dataAttribute} not found: "${attributeValue}"`);
        return null;
      }
    })
    .filter((item) => item !== null);
}

// Optional: Helper function to manually clear initialization for testing
export function clearModuleInitialization(element: HTMLElement) {
  delete element._moduleInitialized;
}
